import React from 'react'
import {LeaseApplication} from '../../types/app-types'
import Alert from '../common/Alert'
import {getConfig} from '../../services/config'

interface ApplicationFormPdfViewerProps {
  leaseApplication: LeaseApplication
  onNext: (e: any) => void
}

const {bluemoonFormsBase} = getConfig()

const ApplicationFormPdfViewer = ({
  leaseApplication,
  onNext
}: ApplicationFormPdfViewerProps) => {
  const {applicationSignatureId, applicationPropertyId} = leaseApplication
  const pdfUrl = `${bluemoonFormsBase}/application/api/property/${applicationPropertyId}/pdf/${applicationSignatureId}`

  return (
    <div>
      <Alert type="success" className="mb-2">
        <p>
          The lease application form is complete. You can review it but it can
          no longer be edited.
          <br />
          <a className="link" onClick={onNext}>
            Please continue with your lease application.
          </a>
        </p>
      </Alert>
      <div className="border border-1 mt-4">
        <object data={pdfUrl} type="application/pdf" width="100%" height="600">
          <p className="p-4">
            The lease application PDF could not be displayed at this time. An
            error occurred or there is not a PDF viewer installed on this
            device.
          </p>
        </object>
      </div>
    </div>
  )
}

export default ApplicationFormPdfViewer
